import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  AUTOSCALING_ELIGIBILITY_PARAM_KEY,
  AUTOSCALING_STATE_PARAM_KEY,
} from '~/shared/utils/autoscalingFilterUtils';
import {
  apiFiltersParamKey,
  PROCESSED_FILTERS_PARAM_KEY,
} from '~/shared/utils/filterUrlParams';

import { parseAppliedVolumeFilters, type ParsedAppliedFilters } from '../appliedFilters';

export type AppliedFiltersResult = ParsedAppliedFilters;

/** Thin React wrapper: all of the parsing lives in `appliedFilters.ts`, where it is tested. */
export function useAppliedVolumeFilters(): AppliedFiltersResult {
  const [searchParams] = useSearchParams();

  const apiFilters = searchParams.get(apiFiltersParamKey);
  const processedFilters = searchParams.get(PROCESSED_FILTERS_PARAM_KEY);
  const autoscalingState = searchParams.get(AUTOSCALING_STATE_PARAM_KEY);
  const autoscalingEligibility = searchParams.get(AUTOSCALING_ELIGIBILITY_PARAM_KEY);

  return useMemo(
    () =>
      parseAppliedVolumeFilters({
        apiFilters,
        processedFilters,
        autoscalingState,
        autoscalingEligibility,
      }),
    [apiFilters, processedFilters, autoscalingState, autoscalingEligibility]
  );
}
